import { createSubtemplate } from "@repo/design-system/lib/client-registry";
import type { SectionKey } from "~/components/job-page/jobpagetemplate/unified-jobpage-template";
import AboutEcon from "~/components/job-page/subclients/econ/about-econ";
import ApplicationProcessEcon from "~/components/job-page/subclients/econ/application-process-econ";
import BehindTheScenesEcon from "~/components/job-page/subclients/econ/behind-the-scenes-econ";
import BenefitsEcon from "~/components/job-page/subclients/econ/benefits-econ";
import CompanyEcon from "~/components/job-page/subclients/econ/company-econ";
import ContactEcon from "~/components/job-page/subclients/econ/contact-econ";
import DiversityEcon from "~/components/job-page/subclients/econ/diversity-econ";
import EventsEcon from "~/components/job-page/subclients/econ/events-econ";
import EvpEcon from "~/components/job-page/subclients/econ/evp-econ";
import ExperienceReportsEcon from "~/components/job-page/subclients/econ/experience-reports-econ";
import FAQ1Econ from "~/components/job-page/subclients/econ/faq1-econ";
import FAQ2Econ from "~/components/job-page/subclients/econ/faq2-econ";
import HeaderImageEcon from "~/components/job-page/subclients/econ/headerimage-econ";
import JobAdTemplateEcon from "~/components/job-page/subclients/econ/jobad-template-econ";
import SocialSectionEcon from "~/components/job-page/subclients/econ/social-section-econ";
import StickyContactEcon from "~/components/job-page/subclients/econ/sticky-contact-econ";

/**
 * ECON client template for the EON registry.
 *
 * This allows econ jobs to be displayed with econ styling when accessed
 * via the eon jobboard (jobs.eon.com), since econ doesn't have its own jobboard!! Right?! :)
 *
 */
export const defaultTemplate = createSubtemplate<SectionKey>({
  name: "econ",
  trigger: () => true,
  showProd: true,
  config: {
    overrides: {
      headerImage: HeaderImageEcon,
      companyInfo: CompanyEcon,
      jobDescription: JobAdTemplateEcon,
      contact: ContactEcon,
      applicationProcess: ApplicationProcessEcon,
      diversity: DiversityEcon,
      experienceReports: ExperienceReportsEcon,
      about: AboutEcon,
      benefits: BenefitsEcon,
      stickyContact: StickyContactEcon,
      socialSection: SocialSectionEcon,
      faq1: FAQ1Econ,
      faq2: FAQ2Econ,
      evpEcon: EvpEcon,
      behindTheScenes: BehindTheScenesEcon,
      events: EventsEcon,
    },
    sections: [
      "stickyContact",
      "headerImage",
      "companyInfo",
      "jobDescription",
      "contact",
      "applicationProcess",
      "faq2",
      "diversity",
      "evpEcon",
      "experienceReports",
      "about",
      "benefits",
      "behindTheScenes",
      "faq1",
      "events",
      "socialSection",
      "printView",
    ],
  },
});
